export const LENIENT_TIME_FORMATS = [
    'H:mm', 
    'h:mm a', 
    'H:mm:ss', 
    'h:mm:ss a'
];
